<div class="log-container">
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#roTab">{{shortTitle}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#dispatchTab">Dispatch</a>
        </li>
    </ul>

    <div class="tab-content mt-3">
        <!-- RO TAB -->
        <div id="roTab" class="tab-pane fade show active">
            <div *ngFor="let item of logData.repairOrder" class="log-item">
            <div class="marker" [style.background]="item.markerBgColorStr"></div>

            <div class="details">
                <b>{{ item.messageStr }}</b> {{ item.dateStr }} <br>
                <small>{{ item.userNameStr }} - {{ item.deviceStr }}</small>
            </div>
            </div>
        </div>

        <!-- DISPATCH TAB -->
        <div id="dispatchTab" class="tab-pane fade">
            <div *ngFor="let item of logData.dispatch" class="log-item">
            <div class="marker" [style.background]="item.markerBgColorStr"></div>

            <div class="details">
                <b>{{ item.messageStr }}</b> {{ item.dateStr }} <br>
                <small>{{ item.userNameStr }} - {{ item.deviceStr }}</small>
            </div>
            </div>
        </div>
    </div>
</div>